import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import autobind from "autobind-decorator";
import { connect } from "react-redux";
import { Container, Row, Col,InputGroup, InputGroupAddon, Button, Input, UncontrolledTooltip, FormGroup, Label} from 'reactstrap';

import http from "../../../../services/HttpService";
import {Redirect} from "react-router";
import Route from "../../../../Routes";
import Loading from "../../../includes/Loading";
import swal from "sweetalert2";
import i18next from 'i18next';
import { Translation } from "react-i18next";

import { FilePond, registerPlugin, create } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

import LayoutDashboard from "../../../../views/layout/Dashboard";
import {layout} from "../../../../../ts-helpers/decorators";

@layout(LayoutDashboard)
@(connect((state) => {
    return { };
}) as any)
export default class EditIndustry extends Component<any> {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
    };

    filePond = null;

    state = {
        name: "",
        specializations: [],
        updated: false,
        loading:true,
        image: [],
        valid: {
            name: true,
            image: true,
        },
        deletedData:[],
        active:true,
    };

    @autobind
    createNewItem() {
        return {
            s_name:""
        };
    }

    constructor(props: Map<any, any>) {
        super(props);
        this.filePond = React.createRef();
    }

    componentDidMount(): void {
        this.getData();
        this.props.onRef(this);
    }

    @autobind
    getData(){
        const { industryId } = this.props.match.params;

        http.get(`/industries/getById/${industryId}`)
            .then(response => response.json())
            .then((data) => {

                this.createFile('/', data.i_image)
                    .then((file) => {
                        const image = [file];

                        this.setState({
                            name: data.i_name,
                            specializations: data.specializations,
                            loading:false,
                            active:data.i_active,
                            image,
                        });
                    });


            });
    }

    async createFile(url, title) {
        let response = await http.get(url + title);
        let data = await response.blob();

        return new File([data], title, {
            type: response.headers.get("Content-Type"),
        });
    }

    @autobind
    updateIndustry(event) {
        event.preventDefault();
        const { name, specializations, valid, deletedData, image, active } = this.state;
        const { industryId } = this.props.match.params;

        if (!valid.name || !valid.image) {
            const list = [];

            !valid.name && list.push("Industry name");
            !valid.image && list.push("Industry image");

            const message = 'Please fill following fields: ' + list.join(', ');
            swal.fire('Failed', message, 'error');

            return;
        }

        const formData = new FormData();
        formData.append("i_name", name);
        formData.append("specializations", JSON.stringify(specializations));
        formData.append("deletedData", JSON.stringify(deletedData));
        formData.append("i_image", image[0] ? image[0].file : null);
        formData.append("i_active", JSON.stringify(active));

        http.withFormData( 'POST',`/industries/update/${industryId}`, formData)
            .then((response: any) => {
                if (response.ok) {
                    swal.fire('Done', 'Partner successfully added.', 'success')
                        .then(() => {
                            this.setState({
                                updated: true,
                            });
                        });
                } else {
                    swal.fire('Failed', 'Something went wrong.', 'error');
                }
            })
            .catch((err) => {
                swal.fire('Failed', 'Something went wrong.', 'error');
            });
    }

    @autobind
    changeIndustryName(event) {
        const { valid } = this.state;
        const name = event.target.value;

        if (name == "") {
            valid.name = false;
        } else {
            valid.name = true;
        }

        this.setState({
            name,
            valid,
        });
    }

    @autobind
    onNumberChange(event, i) {
        const { specializations } = this.state;
        const { industryId } = this.props.match.params;

        specializations[i].s_name = event.target.value;
        specializations[i].industry = industryId;

        this.setNewState(specializations);
    }

    @autobind
    removeItemFromList(event, i) {
        event.stopPropagation();

        const { specializations, deletedData } = this.state;

        if (specializations.length > 0) {
            var item = specializations.splice(i, 1);
        }else{
            specializations.push(this.createNewItem());
        }

        if(item[0]._id){
            deletedData.push(item[0]);
        }

        this.setState({
            deletedData
        });
        this.setNewState(specializations);
    }

    @autobind
    addItemToList(event) {
        event.stopPropagation();

        const { specializations } = this.state;
        specializations.push(this.createNewItem());

        this.setNewState(specializations);
    }

    @autobind
    setNewState(specializations) {
        this.setState({
            specializations,
        });

        //this.props.onChange(items);
    }

    @autobind
    changeImage(files) {
        const { valid } = this.state;
        if (files.length == 0) {
            valid.image = false;
        } else {
            valid.image = true;
        }

        this.setState({
            image: files,
            valid,
        });
    }

    @autobind
    handleActive() {
        this.setState({active: !this.state.active});
    }

    @autobind
    changeLanguage(e) {
        const lng = e.currentTarget.dataset.lang
        this.setState({ lng: lng }, () => {
            i18next.changeLanguage(lng);
            this.props.changeLang();
        });
    }

    @autobind
    langTranslation(e){
        return <Translation>{t => t(`${e}`)}</Translation>
    }

    render() {
        const { loading, name, specializations, deletedData, updated, image, active } = this.state;

        if (updated) {
            return <Redirect to={Route.toUrl("dashboard_industry_all")} />
        }

        return(
            <Container fluid>
                <Row>
                    <Col className="sm-12">
                        <h4 className="header-title m-t-0 m-b-20">Edit industry / {name}</h4>
                    </Col>
                </Row>
                {
                    loading ? <Container><Row><Col className="text-center"><Loading isLoading={loading} icon="loadDashboardInfo"/></Col></Row></Container> :
                    <Fragment>
                        <Row>
                            <Col className="dashboard_add_style_block col-sm-offset-3 col-sm-6">
                                <form onSubmit={this.updateIndustry}>
                                    <Row>
                                        <Col className="col-sm-9">
                                            <FormGroup className="mt-4">
                                                <Label for="name" className="dashboard_forms_label">Industry name<sup className="my_sup_class">*</sup></Label>
                                                <Input
                                                    type="text" placeholder="Industry name"
                                                    className="contact_form_input" id="name"
                                                    value={name} onChange={this.changeIndustryName}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col className="col-sm-3 text-center">
                                            <Label for="title" className="dashboard_forms_label">Active-Inactive</Label>
                                            <div>
                                                <input
                                                    className="dashboard_featured_cachkbox"
                                                    type="checkbox"
                                                    onChange={this.handleActive}
                                                    defaultChecked={active}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label for="name" className="dashboard_forms_label">Specializations<sup className="my_sup_class">*</sup></Label>
                                                {this.state.specializations.map((item, i) => (
                                                    <div className="row" key={i}>
                                                        <div className="col-sm-12 specialization_item_input">
                                                            <div className="col-sm-11">
                                                                <Input value={item.s_name} onChange={(e) => this.onNumberChange(e, i)} id="carNumber"/>
                                                            </div>
                                                            <div className="col-sm-1">
                                                                <Button size="sm" color="danger" className="specialization_remove_link" onClick={(e) => this.removeItemFromList(e, i)}>
                                                                    <i className="fa fa-times" />
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}

                                                <div className="row">
                                                    <div className="col-sm-12 text-right">
                                                        <Button size="sm" color="primary" className="specialization_add_item_link" onClick={this.addItemToList}>
                                                            <i className="fa fa-plus" />
                                                        </Button>
                                                    </div>
                                                </div>
                                            </FormGroup>
                                            <FormGroup className="mt-4">
                                                <Label for="image" className="dashboard_forms_label">Image<sup className="my_sup_class">*</sup></Label>
                                                <FilePond allowMultiple={false} files={image} ref={this.filePond}
                                                          onupdatefiles={this.changeImage} acceptedFileTypes={['image/*']}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <div className="text-center">
                                        <Button className="dashboard_add_form_button">Update</Button>
                                    </div>
                                </form>
                            </Col>
                        </Row>
                    </Fragment>
                }
            </Container>
        );

    }
}
